module.exports = __webpack_public_path__ + "images/lpage-certificates-2.png";